import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import { ETimeBucketType } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { selectCampaignsChartReportingFilters } from '../../../store/reportingFilters'
import { dayjsFormat } from '../../../utils/helpers/dayjsFormat'

dayjs.extend(customParseFormat)
dayjs.extend(quarterOfYear)
dayjs.extend(weekOfYear)
dayjs.extend(advancedFormat)

export const useGetFormattedDate = ({ date }: { date: string | number }) => {
  const intl = useIntl()
  const { aggregationType: reduxAggregationType } = useSelector(
    selectCampaignsChartReportingFilters
  )
  const aggregationType = reduxAggregationType || ETimeBucketType.Daily

  if (!date) {
    return ''
  }

  const stringifiedDate = String(date)

  if (aggregationType === ETimeBucketType.Daily) {
    const parsedDate = dayjs(stringifiedDate)
    if (!parsedDate.isValid()) return ''
    return parsedDate.format(dayjsFormat)
  }

  if (aggregationType === ETimeBucketType.Weekly) {
    const [year, week] = stringifiedDate.split('-')
    if (!year || !week || isNaN(Number(year)) || isNaN(Number(week))) return ''

    const parsedDate = dayjs().year(Number(year)).week(Number(week))
    if (!parsedDate.isValid()) return ''

    const weekString = intl.formatMessage({ id: `week` })
    return `${weekString} ${parsedDate.format('ww, YYYY')}`
  }

  if (aggregationType === ETimeBucketType.Monthly) {
    const parsedDate = dayjs(stringifiedDate, 'YYYY-M')
    if (!parsedDate.isValid()) return ''
    return parsedDate.format('MMMM, YYYY')
  }

  if (aggregationType === ETimeBucketType.Quarterly) {
    const [year, quarter] = stringifiedDate.split('-')
    if (!year || !quarter || isNaN(Number(year)) || isNaN(Number(quarter)))
      return ''

    const parsedDate = dayjs().year(Number(year)).quarter(Number(quarter))
    if (!parsedDate.isValid()) return ''

    const quaterlyShortString = intl.formatMessage({ id: `quaterly-short` })
    return `${quaterlyShortString}${parsedDate.format('Q, YYYY')}`
  }

  // this applies for unsupported ETimeBucketType and ETimeBucketType.Yearly
  return date
}
